function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSpotifyColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_x5F_spotify_x5F_color",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "logo_x5F_spotify_x5F_color_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#25D24E"
    },
    d: "M24,4C12.954,4,4,12.954,4,24c0,11.047,8.954,20,20,20c11.046,0,20-8.954,20-20 C44,12.954,35.046,4,24,4z M33.172,32.847c-0.359,0.589-1.127,0.774-1.714,0.415c-4.697-2.871-10.608-3.519-17.57-1.929 c-0.671,0.154-1.339-0.267-1.493-0.937c-0.154-0.671,0.265-1.339,0.938-1.492c7.618-1.742,14.154-0.992,19.425,2.229 C33.346,31.492,33.531,32.259,33.172,32.847z M35.619,27.401c-0.452,0.734-1.412,0.964-2.145,0.513 c-5.375-3.304-13.57-4.261-19.929-2.331c-0.825,0.249-1.696-0.216-1.946-1.039c-0.248-0.825,0.217-1.694,1.04-1.945 c7.264-2.204,16.294-1.137,22.467,2.657C35.839,25.709,36.07,26.669,35.619,27.401z M35.831,21.73 c-6.447-3.829-17.081-4.181-23.235-2.313c-0.988,0.3-2.033-0.258-2.333-1.246c-0.3-0.989,0.258-2.033,1.247-2.334 c7.065-2.145,18.809-1.73,26.231,2.675c0.889,0.528,1.181,1.676,0.654,2.563C37.866,21.965,36.717,22.258,35.831,21.73z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSpotifyColor);
export default __webpack_public_path__ + "static/media/logo_spotify_color.fcbb0e1367e892934fceeddf026c3987.svg";
export { ForwardRef as ReactComponent };